import { render } from "./changePwd.vue?vue&type=template&id=5f0cca62&scoped=true"
import script from "./changePwd.vue?vue&type=script&lang=js"
export * from "./changePwd.vue?vue&type=script&lang=js"

import "./changePwd.vue?vue&type=style&index=0&id=5f0cca62&lang=scss&scoped=true"

import exportComponent from "/home/k8s/workspace/maxHu/nielsen-yq/prod/nielsen-yq-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0cca62"]])

export default __exports__